<!-- 供应商-详情 -->
<template>
	<div class="wrap">

		<div class="header-wrap">
			<div class="header">
				<img src="../assets/return.png" class="return-img" @click="$router.back()">
			</div>
		</div>

		<div class="swiper-box">
			<img src="../assets/img.png" class="swiper-img">
			<p class="diandian">
				1/3
			</p>
		</div>

		<div class="top-box">
			<div class="top-box-left">
				<p class="top-box-left-name">高隔断铝型材料制造及销售</p>
				<ul class="tag-list">
					<li>建筑石材</li>
					<li>建筑石材</li>
				</ul>
			</div>
			<div class="top-box-right" v-if="imageText">
				<img src="../assets/icon-70.png">
				跳转图文
			</div>
			<div class="top-box-right" v-if="video">
				<img src="../assets/icon-70.png">
				跳转视频
			</div>
			<div class="top-box-right" v-if="information">
				<img src="../assets/icon-70.png">
				跳转资料
			</div>
		</div>

		<div class="message-wrap">
			<p class="message-label">公司信息</p>
			<div class="company-box">
				<img src="../assets/img.png" class="company-message-img">
				<p class="company-message-name">山东盛工绿筑科技有限公司</p>
			</div>
			<div class="company-row">
				<span class="company-row-label">成立日期</span>
				<span class="company-row-msg">2012-07-18</span>
			</div>
			<div class="company-row">
				<span class="company-row-label">办公地点</span>
				<span class="company-row-msg">上海 浦东</span>
			</div>
			<div class="company-row">
				<span class="company-row-label">主营业务</span>
				<span class="company-row-msg">软硬件开发、养老院、护理院、结构、CCRC、康养中心、旅居基地</span>
			</div>
		</div>

		<div class="bottom">
			<p class="bottom-label">产品详情</p>
			<p class="bottom-msg">
				根据《中华人民共和国价格法》、《中华人民共和国商业银行法》、《商业银行服务价格管理办法》、《国家发展改革委
				中国银监会关于印发商业银行服务政府指导价政府定价目录的通知》、《中国银保监会关于规范银行服务市场调节价管理的指导意见》等规定，按照“收费项目公开、服务质价公开、效用功能公开、优惠政策公开”的“四公开”要求，现将本行各项金融服务价格标准予以公告。本公告内容包括服务提示、政府指导价政府定价项目价格标准、中国农业银行免费服务项目及中国农业银行市场调节价服务价格标准等，自2022年4月30日起执行。
			</p>
		</div>

		<div class="footer">
			<div class="footer-wrap">
				<ul class="footer-list">
					<li>
						<img src="../assets/shou-active.png" class="footer-icon" v-if="is_like == 1">
						<img src="../assets/shou.png" class="footer-icon" v-else>
						<span class="blue" v-if="is_like == 1">12</span>
						<span class="gray" v-else>12</span>
					</li>
					<li>
						<img src="../assets/xing-active.png" class="footer-icon" v-if="is_collect == 1">
						<img src="../assets/xing.png" class="footer-icon" v-else>
						<span class="blue" v-if="is_collect == 1">4</span>
						<span class="gray" v-else>4</span>
					</li>
					<li>
						<img src="../assets/icon-29.png" class="footer-icon">
						12
					</li>
				</ul>
				<button type="button" class="footer-btn" @click="$router.push('/supplier-contact')">联系我们</button>
			</div>
		</div>


	</div>
</template>

<script>
	export default {
		components: {},
		data() {
			return {
				is_like: 0,
				is_collect: 0,
				imageText: true,
				information: false,
				video: false
			};
		},
		mounted() {

		},
		methods: {

		}
	}
</script>

<style scoped>
	.wrap {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 0 0 83px;
		box-sizing: border-box;
	}

	/* 头部样式 */
	.header-wrap {
		width: 100%;
		height: 44px;
		display: flex;
		flex-direction: column;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 500;
		background: rgba(0, 0, 0, 0);
	}

	.header-wrap-tab-list-none {
		height: 80px;
		padding-bottom: 10px;
	}

	.header {
		width: 100%;
		height: 44px;
		display: flex;
		align-items: center;
		justify-content: center;
		z-index: 999;
		padding: 0 15px;
		position: relative;
		box-sizing: border-box;
	}

	.return-img {
		position: absolute;
		left: 15px;
		top: 50%;
		transform: translate(0, -50%);
		width: 20px;
	}

	.header-title {
		color: #333333;
		font-size: 18px;
		font-weight: 500;
	}

	.footer {
		width: 100%;
		height: 83px;
		position: fixed;
		bottom: 0;
		left: 0;
		z-index: 999;
		background-color: #FFFFFF;
		display: flex;
		justify-content: center;
		align-items: flex-start;
		padding: 6px 15px 0 0;
		box-sizing: border-box;
	}

	.footer-wrap {
		width: 100%;
		display: flex;
		align-items: center;
	}

	.footer-list {
		flex: 1;
		display: flex;
		align-items: center;
		margin-right: 50px;
	}

	.footer-list>li {
		flex: 1;
		display: flex;
		flex-direction: column;
		align-items: center;
		color: #222222;
		font-size: 10px;
	}

	.footer-icon {
		height: 18px;
		margin-bottom: 4px;
	}

	.footer-btn {
		width: 106px;
		height: 40px;
		line-height: 40px;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 16px;
		font-weight: bold;
		color: #FFFFFF;
		background-color: #2A63F3;
		border-radius: 50px;
	}

	.blue {
		color: #2A63F3;
		font-size: 10px;
	}

	.gray {
		font-size: 10px;
		color: #333333;
	}

	.top-box {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 10px 15px;
		box-sizing: border-box;
		border-bottom: 10px solid #F3F3F3;
	}


	.swiper-box {
		width: 100%;
		position: relative;
	}

	.swiper-img {
		width: 100%;
		height: 280px;
	}

	.diandian {
		position: absolute;
		right: 15px;
		bottom: 10px;
		border-radius: 30px;
		width: 38px;
		height: 16px;
		line-height: 16px;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #FFFFFF;
		font-size: 11px;
		background: rgba(0, 0, 0, 0.4);
	}

	.tag-list {
		flex: 1;
		display: flex;
		flex-wrap: wrap;
	}

	.tag-list>li {
		height: 18px;
		line-height: 18px;
		display: flex;
		align-items: center;
		font-size: 10px;
		width: fit-content;
		padding: 0 6px;
		border-radius: 2px;
		margin-right: 10px;
		color: #4FA753;
		background-color: #E8F6EA;
	}

	.top-box-left {
		flex: 1;
		display: flex;
		flex-direction: column;
	}

	.top-box-left-name {
		width: 100%;
		font-size: 18px;
		color: #333333;
		font-weight: bold;
		margin-bottom: 5px;
	}

	.top-box-right {
		color: #2A63F3;
		font-size: 11px;
		display: flex;
		flex-direction: column;
		align-items: center;
		padding-left: 12px;
		box-sizing: border-box;
		border-left: 1px solid #F4F4F4;
	}

	.top-box-right>img {
		width: 20px;
		margin-bottom: 1px;
	}

	.message-wrap {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 0 15px;
		border-bottom: 10px solid #F4F4F4;
		box-sizing: border-box;
	}

	.message-label {
		width: 100%;
		height: 44px;
		line-height: 44px;
		border-bottom: 1px solid #F4F4F4;
		box-sizing: border-box;
		color: #111111;
		font-size: 16px;
		font-weight: bold;
	}

	.company-box {
		width: 100%;
		display: flex;
		align-items: center;
		padding: 14px 0;
		border-bottom: 1px solid #F3F3F3;
		box-sizing: border-box;
	}

	.company-message-img {
		width: 44px;
		height: 44px;
		border-radius: 4px;
		margin-right: 10px;
	}

	.company-message-name {
		flex: 1;
		font-size: 15px;
		color: #222222;
		font-weight: bold;
	}

	.company-row {
		width: 100%;
		display: flex;
		align-items: flex-start;
		padding: 14px 0;
		border-bottom: 1px solid #F3F3F3;
		box-sizing: border-box;
	}

	.company-row:last-of-type {
		border-bottom: none;
	}

	.company-row-label {
		width: 66px;
		color: #666666;
		font-size: 12px;
	}

	.company-row-msg {
		flex: 1;
		font-size: 12px;
		color: #222222;
		font-weight: bold;
	}

	.bottom {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 0 15px 15px;
		box-sizing: border-box;
	}

	.bottom-label {
		width: 100%;
		height: 44px;
		line-height: 44px;
		font-size: 16px;
		color: #111111;
		font-weight: bold;
	}

	.bottom-msg {
		width: 100%;
		color: #444444;
		font-size: 13px;
	}
</style>
